import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/cici/cici/components/BlogList.tsx");
